import { generateUUID } from 'app/shared/utils/uuid.util';
import { EventRow } from './logger.event-row';
import { loggerConstants } from 'app/logger/logger.constants';

export type WizardAction = 'open' | 'goBack' | 'goNext' | 'reload' | 'finish' | 'cancel' | 'info' | 'error' | 'click' | 'commit';

export class WizardEvent extends EventRow {
    private static sessionId: string = '';

    public constructor(
        step: string,
        substep: string,
        page: string,
        action: string,
        message?: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalInfo?: { [key: string]: any }
    ) {
        super(
            additionalInfo?.eventName || loggerConstants.Event_CopyWizard, {
            ['sessionId']: WizardEvent.sessionId,
            ['step']: step,
            ['page']: page,
            ['substep']: substep,
            ['action']: action,
            ['message']: message || '',
            ...(additionalInfo || {})
        }
        );
    }

    public static createSession(): void {
        WizardEvent.sessionId = generateUUID();
    }
}
